import { KeyboardEvent, MouseEvent, useEffect, useRef } from 'react';

import { StyledTokenFieldBlock } from './TokenFieldBlock.styled';

/* ---------------------------------- Types --------------------------------- */

/** @interface `DumbTokenFieldBlockI`
 * #### Interface for the TokenField's props object
 */
export interface DumbTokenFieldBlockI {
    /** Handles changing the value of the input field */
    handleChange: (character: string) => void;

    /** Move focus to the previous input field */
    moveToPrevious: () => void;

    /** Value displayed in the input field */
    value: string;

    /** Denotes if the input field is in focus */
    isActive: boolean;
}

/* --------------------------- Build the Component -------------------------- */

/** @function `TokenField()`
 * #### The TokenField component
 *
 * Displays an input field for a single token character.
 *
 * @param props  An object containing all the props needed to render this component
 */
const DumbTokenFieldBlock = ({
    moveToPrevious,
    value,
    handleChange,
    isActive,
}: DumbTokenFieldBlockI) => {
    const inputRef = useRef<HTMLInputElement>(null);

    // detect backspace
    const keyPressed = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Backspace') {
            moveToPrevious();
        }
    };

    // select content, for mouse users
    const selectText = (event: MouseEvent) => {
        event.preventDefault();
        inputRef.current?.focus();
        inputRef.current?.select();
    };

    useEffect(() => {
        if (inputRef) {
            if (isActive) {
                inputRef.current?.focus();
                inputRef.current?.select();
            }
        }
    }, [isActive]);

    return (
        <StyledTokenFieldBlock
            type="text"
            ref={inputRef}
            value={value}
            maxLength={1}
            onKeyDown={keyPressed}
            onClick={(event) => selectText(event)}
            onChange={(event) => handleChange(event.target.value)}
        />
    );
};

/* --------------------------- Export the Component ------------------------- */

export default DumbTokenFieldBlock;
